export const styles = {
  card: { padding: '2.5rem', marginBottom: '2rem' },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    marginTop: '1rem',
    marginBottom: '2rem',
  },
  input: {
    margin: '20px 0',
  },
  dropzone: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '34px',
  },
  country: {
    fontSize: 16,
    margin: '20px 0',
    color: '#546b81',
  },
  hint: {
    color: '#707087',
    marginTop: '4px',
  },
  checkboxWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  xeroTitle: {
    marginBottom: '30px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  apiCheckboxWrapper: {
    marginTop: 14,
    display: 'flex',
    flexDirection: 'column',
  },
  sftpCheckboxWrapper: {
    marginTop: 14,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  whiteTooltip: {
    backgroundColor: '#fff',
    color: 'rgba(0, 0, 0, 0.87)',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
    fontSize: 13,
  },
  budgetInput: {
    '& input[type=number]': {
      MozAppearance: 'textfield',
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
      paddingLeft: '30px',
      paddingRight: '20px',
    },
  },
}
